import TicketsApi from '@app/api/public/TicketsApi';
import { ticketQueryKeys } from '@app/shared/queryKeys/tickets';
import { useQuery } from 'react-query';

const useGetResponseText = () => {
    return useQuery(ticketQueryKeys.responseText(), () => TicketsApi.getResponseText());
};

export { useGetResponseText };
